<div class="w-full h-full p-2 flex flex-wrap items-start bg-gray-50 dark:bg-gray-800 rounded-md relative">
  <!-- ? Title -->
  <div class="w-full flex items-center justify-between">
    <p class="text-gray-900 text-sm md:text-xs ml-2">
      انتخاب تصویر به دیده‌شدن شما کمک می‌کند.
    </p>

    <button class="!h-5 !w-5 !min-w-5 !min-h-5 py-4 icon-btn absolute left-0 dark:hover:bg-gray-900"
      (click)="closeSuggestion()">
      <span class="icon dismiss-filled text-sm"></span>
    </button>
  </div>

  <!-- ? User Action -->
  <div class="w-full flex mt-3 items-center">
    <button class="icon-btn border border-gray-500 dark:border-gray-400" (click)="uploadAvatar()">
      <span class="icon camera-regular text-sm text-gray-500 cursor-pointer"></span>
    </button>
    <div class="grow pr-2 flex flex-wrap">
      <div class="w-full">
        <p class="text-sm text-gray-900">
          {{ currentUser?.firstName }}
        </p>
      </div>
      <div class="w-full mt-2">
        <p class="text-sm text-gray-500 text-right" dir="ltr">
          {{'@' + currentUser?.uniqeName }}
        </p>
      </div>
    </div>
  </div>
</div>
